import { useEffect } from 'react';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { getPackagingProductById } from 'src/redux/slices/packaging-product';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import { LoadingScreen } from '../../../components/loading-screen';
import { useAppDispatcher, useAppSelector } from '../../../redux/store';
import PackagingProductNewEditForm from '../packaging-product-new-edit-form';

type Props = {
  id: string;
};

export default function PackagingProductEditView({ id }: Props) {
  const { product, status, error } = useAppSelector((state) => state.packagingProduct);

  const settings = useSettingsContext();
  const dispatch = useAppDispatcher();

  useEffect(() => {
    dispatch(getPackagingProductById({ productId: id }));
  }, [dispatch, id]);

  if (status === 'loading' || status === 'idle') {
    return <LoadingScreen />;
  }

  if (status === 'failure') {
    return (
      <ErrorContent
        filled
        title="Failed to load product details"
        description={error}
        action={
          <Button
            component={RouterLink}
            href={paths.dashboard.packagingProduct.root}
            variant="contained"
            startIcon={<LeftIcon />}
          >
            Back to Products
          </Button>
        }
        sx={{
          py: 10,
        }}
      />
    );
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Edit product"
        links={[
          {
            name: 'Products',
            href: paths.dashboard.packagingProduct.root,
          },
          { name: 'Edit product' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <PackagingProductNewEditForm currentProduct={product} />
    </Container>
  );
}
